import styled from '@emotion/styled'

export const Video = styled.video`
  border-radius: 0;
`

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #13212b;
  overflow: hidden;
`

export const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  gap: 0;
  padding: 0;
  width: 100%;
  height: 100%;
`

export const ChannelsSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 40px;
`

export const ChannelsHeader = styled.h1`
  font-size: 40px;
  font-weight: 800;
  color: #ffffff;
  margin: 0 0 24px 0;
  letter-spacing: -0.5px;
`

export const ChannelGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding: 20px;
  gap: 20px;
  padding-right: 8px;
  flex: 1;
`

export const ChannelCard = styled.div<{ selected?: boolean }>`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.02);
  }

  &:focus {
    outline: none;
  }
`

export const ChannelThumbnailWrapper = styled.div<{ selected?: boolean }>`
  width: 100%;
  aspect-ratio: 16/9;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  border: ${({ selected }) => (selected ? '3px solid #ffffff' : '3px solid rgba(255, 255, 255, 0.15)')};
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
  margin-bottom: 0;
  box-shadow: ${({ selected }) => (selected ? '0 0 0 6px rgba(255,255,255,0.08)' : 'none')};
`

export const ChannelThumbnail = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  font-weight: bold;
  position: relative;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const ChannelOverlay = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px 14px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%);
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
`

export const ChannelOverlayName = styled.div`
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const DurationBadge = styled.div`
  color: #0b1520;
  background: #ffffff;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  opacity: 0.9;
`

export const ChannelInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 10px;
`

export const ChannelName = styled.div`
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const ChannelDuration = styled.div`
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  font-weight: 400;
`

export const VideoContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: relative;
  padding: 0;
  /*
  .SL-AdvertisementWebOs--notification {
    position: absolute;
    left: 0;
    bottom: 0;
    top: auto;
    z-index: 1000;
  }

  .SL-AdvertisementWebOs--banner {
    position: absolute;
    left: 10px;
    right: 360px;
    bottom: 10px;
    top: auto;
    z-index: 1000;
    height: 90px;
  }

  .SL-AdvertisementWebOs--sidebar {
    position: absolute;
    width: 350px;
    right: 0;
    top: 0;
    bottom: 0;
  }

  .SL_PauseAd {
    width: 300px !important;
    left: auto !important;
  } */
`

export const VideoWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const TopBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 80px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%);
  z-index: 30;
  opacity: 0;
  transition: opacity 0.3s ease;

  ${ContentWrapper}:hover & {
    opacity: 1;
  }

  ${ContentWrapper}:focus-within & {
    opacity: 1;
  }
`

export const BackButton = styled.button`
  appearance: none;
  border: none;
  outline: none;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  height: 44px;
  padding: 0 40px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 26px;
  font-weight: 600;
  cursor: pointer;
  backdrop-filter: blur(8px);
  text-transform: uppercase;
  letter-spacing: 1.37px;
  line-height: 32px;
  transition:
    background 0.2s ease,
    transform 0.1s ease,
    box-shadow 0.2s ease;

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.18);
  }

  &:active,
  &:focus,
  &[data-tv-focused='true'] {
    background: #ffffff;
    color: #000000;
    box-shadow: 0px 15px 20px 0px rgba(0, 0, 0, 0.25);
    transform: scale(0.98);
  }
`

export const PlayPauseButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  outline: none;

  border: none;
  background: none;
  color: rgba(0, 0, 0, 0.8);

  cursor: pointer;
  z-index: 10;
  transition: all 0.2s ease;
  opacity: 0;

  font-size: 80px;

  font-variation-settings:
    'FILL' 1,
    'wght' 700,
    'GRAD' 0,
    'opsz' 24;

  &:hover {
    transform: translate(-50%, -50%) scale(1.1);
  }

  &:active {
    transform: translate(-50%, -50%) scale(0.95);
  }

  &:focus {
    color: rgba(255, 255, 255, 0.8);
  }

  ${ContentWrapper}:hover & {
    opacity: 1;
  }

  ${ContentWrapper}:focus-within & {
    opacity: 1;
  }
`

export const PauseAdOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  overflow: hidden;
  animation: fadeIn 0.3s ease-in-out;

  &.pause-ad-closing {
    animation: fadeOut 0.3s ease-in-out forwards;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      scale: 1.5;
    }
    to {
      opacity: 1;
      scale: 1;
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
      scale: 1;
    }
    to {
      opacity: 0;
      scale: 1.5;
    }
  }
`

export const PauseAdContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

export const PauseAdGradientLeft = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 737px;
  height: 100%;
  background: linear-gradient(to right, #000000 0%, rgba(10, 14, 19, 0) 100%);
  opacity: 0.5;
  pointer-events: none;
`

export const PauseAdGradientRight = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  left: calc(58.33% + 63px);
  height: 100%;
  background: linear-gradient(to right, rgba(10, 14, 19, 0) 0%, #000000 100%);
  pointer-events: none;
`

export const PauseAdGradientBottom = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 320px;
  background: linear-gradient(to bottom, rgba(10, 14, 19, 0) 0%, #0a0e13 80%);
  opacity: 0.5;
  pointer-events: none;
`

export const PauseAdTopLeft = styled.div`
  position: absolute;
  top: 60px;
  left: 80px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 21;
`

export const PauseAdTitle = styled.h2`
  color: #ffffff;
  font-size: 48px;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
  letter-spacing: 0.38px;
`

export const PauseAdCaption = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 26px;
  font-weight: 400;
  margin: 0;
  line-height: 1.35;
  letter-spacing: -0.32px;
`

export const PauseAdBottomLeft = styled.div`
  position: absolute;
  bottom: 60px;
  left: 60px;
  z-index: 21;
`

export const PauseAdPlayButton = styled.button`
  width: 136px;
  height: 136px;
  border: none;
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;

  &:hover {
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`

export const PauseAdSidebar = styled.div`
  position: absolute;
  top: 50%;
  right: 30px;
  transform: translateY(-50%);
  width: 315px;
  height: 400px;
  z-index: 21;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
`

export const PauseAdPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  text-align: center;
  padding: 20px;
  border: 1px solid rgba(255, 255, 255, 0.2);
`

export const BottomBar = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  padding: 0 42px 42px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%);
  z-index: 30;
  opacity: 0;
  transition: opacity 0.3s ease;

  ${ContentWrapper}:hover & {
    opacity: 1;
  }

  ${ContentWrapper}:focus-within & {
    opacity: 1;
  }
`

export const VideoInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`

export const LiveChannelLabel = styled.div`
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.8;
`

export const VideoTitle = styled.h2`
  color: #ffffff;
  font-size: 32px;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
`

export const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const TimelineBar = styled.div`
  position: relative;
  width: 100%;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  overflow: hidden;
`

export const TimelineProgress = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  background: #ffffff;
  border-radius: 2px;
  transition: width 0.1s linear;
`

export const TimelineHandle = styled.div`
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.3);
  transition: left 0.1s linear;
`

export const TimeDisplay = styled.div`
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  opacity: 0.9;
`

export const ExternalAdContainer = styled.div`
  width: 100%;
  height: 100%;
  aspect-ratio: 1 / 1;
  position: relative;

  .video-js {
    background: transparent;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .video-js .vjs-tech {
    position: relative;
  }

  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .vast-skip-button {
    display: block;
    position: absolute;
    bottom: 5px;
    right: 0;
    width: auto;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 12px;
    padding: 10px;
    opacity: 0.9;
    z-index: 2;
    cursor: pointer;
    border: 1px solid #fff;

    &:hover {
      opacity: 1;
    }
  }

  .vast-remaining-time {
    display: block;
    position: absolute;
    bottom: 35px;
    left: 75px;
    width: auto;
    color: #aaa;
    font-size: 12px;
    font-style: italic;
    line-height: 12px;
    z-index: 2;
  }

  .vast-remaining-time-icon {
    position: absolute;
    color: #aaa !important;
    font-size: 20px !important;
    z-index: 2;
  }

  .vast-remaining-time-icon:focus {
    text-shadow: 0 0 1em #fff;
  }

  .vast-remaining-time-icon-play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 44px;
    height: 44px;
    border-radius: 50%;
    padding: 0;

    background-color: rgba(0, 0, 0, 0.5);
    background-repeat: no-repeat;
    background-position: center;

    cursor: pointer;

    &:before {
      content: '';
      display: none;
    }
  }
`
